import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Breadcrumbs = () => {
  const { t } = useTranslation();

  return (
    <section id="breadcrumbs" className="breadcrumbs">
      <div className="container">
        <div className="d-flex justify-content-between align-items-center">
          <h2>Work</h2>
          <ol>
            <li>
              <Link to="/">{t("Home")}</Link>
            </li>
            <li>{t("My Work")}</li>
          </ol>
        </div>
      </div>
    </section>
  );
};

export default Breadcrumbs;
